import {
  CalendarDays,
  CircleUserRound,
  ClipboardList,
  House,
  Import,
  Megaphone,
  PlusCircle,
  School,
  Settings,
  SquareCheckBig,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** Shorter label for the phone tab bar, where space is tight. */
  tabLabel?: string;
}

/** Home is the Dashboard (Mike, 2026-09-30). */
export const HOME = "/dashboard";

const home: NavItem = { to: HOME, label: "Dashboard", icon: House, tabLabel: "Home" };
const checklist: NavItem = { to: "/checklist", label: "Checklist", icon: SquareCheckBig };
const calendar: NavItem = { to: "/calendar", label: "Calendar", icon: CalendarDays };
const assignments: NavItem = { to: "/assignments", label: "Assignments", icon: ClipboardList };
const schedule: NavItem = { to: "/schedule", label: "My Classes", icon: School };
const announcements: NavItem = { to: "/announcements", label: "Announcements", icon: Megaphone };
const addHomework: NavItem = { to: "/add", label: "Add Homework", icon: PlusCircle };
/** Paste or screenshots from a school website, for schools without the Classroom connection (Mike, 2026-10-01). */
const importPage: NavItem = { to: "/import", label: "Import", icon: Import };
const profile: NavItem = { to: "/profile", label: "Profile", icon: CircleUserRound };
const settings: NavItem = { to: "/settings", label: "Settings", icon: Settings };

/** Desktop left sidebar. Profile, Settings and Sign out live in the profile menu (top right). */
export const SIDEBAR_NAV: NavItem[] = [home, checklist, calendar, assignments, schedule, announcements, addHomework, importPage];

/** Phone bottom tabs, followed by "More". */
export const PHONE_TABS: NavItem[] = [home, checklist, calendar, assignments];

/** Behind the "More" tab on phones. */
export const MORE_NAV: NavItem[] = [announcements, schedule, addHomework, importPage, profile, settings];

/** The profile menu, top right on desktop. */
export const ACCOUNT_NAV: NavItem[] = [profile, settings];
